export const PeopleIcon = () => {
  return (
    <svg
      width="50"
      height="51"
      viewBox="0 0 50 51"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="25" cy="25.5156" r="25" fill="#CFFFDA" />
      <g clipPath="url(#clip0_1695_5315)">
        <path
          d="M22.1133 19.8139C22.1133 21.6858 23.6362 23.1771 25.4765 23.1771C26.1745 23.1771 26.8091 22.9867 27.3167 22.606C27.3485 22.606 27.3485 22.5742 27.3802 22.5742C28.2686 21.9714 28.8397 20.9561 28.8397 19.7821C28.8397 17.9102 27.3167 16.4189 25.4765 16.4189C23.6362 16.4189 22.1133 17.9419 22.1133 19.8139Z"
          fill="#28A745"
        />
        <path
          d="M31.6324 29.0148C31.6324 26.4131 30.0142 24.0969 27.5712 23.2402C26.302 24.0017 24.7156 24.0334 23.4147 23.2402C20.9717 24.1286 19.3535 26.4131 19.3535 29.0148C19.3535 30.5377 22.5263 31.3627 25.5088 31.3627C28.4913 31.3627 31.6324 30.5377 31.6324 29.0148Z"
          fill="#28A745"
        />
        <path
          d="M17.4805 24.542C17.4805 25.589 18.4006 26.3187 19.3207 26.2236C19.6697 25.4303 20.1774 24.7323 20.8119 24.1295C20.6216 23.3997 19.9553 22.8604 19.1938 22.8604C18.2419 22.8604 17.4805 23.6218 17.4805 24.542Z"
          fill="#28A745"
        />
        <path
          d="M15.4512 29.0782C15.4512 29.2368 15.5464 29.3954 15.705 29.5224C16.3078 30.03 17.7356 30.2838 19.1634 30.1887C18.4019 29.6175 18.2115 29.0147 18.2115 28.5388C18.2115 27.7773 18.3384 27.0793 18.5605 26.3813C18.2115 26.3495 17.8625 26.2543 17.5452 26.0957C16.2444 26.5716 15.4512 27.7456 15.4512 29.0782Z"
          fill="#28A745"
        />
        <path
          d="M34.9969 29.5538C34.9969 28.2212 34.172 27.0472 32.9346 26.5713C32.6173 26.7617 32.2683 26.8568 31.9192 26.8568C32.1413 27.5231 32.2683 28.2529 32.2683 29.0144C32.2683 29.6807 31.9192 30.22 31.3164 30.6642C32.4904 30.7277 34.9969 30.4739 34.9969 29.5538Z"
          fill="#28A745"
        />
        <path
          d="M31.8232 22.8604C31.03 22.8604 30.3954 23.368 30.2051 24.1295C30.8396 24.7323 31.3473 25.4303 31.6963 26.2553C32.6482 26.3505 33.5048 25.589 33.5048 24.5737C33.5048 23.6218 32.7433 22.8604 31.8232 22.8604Z"
          fill="#28A745"
        />
      </g>
      <defs>
        <clipPath id="clip0_1695_5315">
          <rect
            width="20"
            height="16.3599"
            fill="white"
            transform="translate(15 15.5645)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
